import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "ranking-user" }
const _hoisted_2 = { class: "ranking-user-left" }
const _hoisted_3 = { class: "ranking-number" }
const _hoisted_4 = {
  key: 1,
  class: "user-circle"
}
const _hoisted_5 = { class: "ranking-user-right" }
const _hoisted_6 = { class: "user-name" }
const _hoisted_7 = { class: "user-score-container" }
const _hoisted_8 = { class: "user-score-point" }
const _hoisted_9 = /*#__PURE__*/_createVNode("p", { class: "user-score" }, "score", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Imgix = _resolveComponent("Imgix")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("p", _hoisted_3, _toDisplayString(_ctx.index + 4), 1),
      (_ctx.path != '')
        ? (_openBlock(), _createBlock(_component_Imgix, {
            key: 0,
            class: "user-circle",
            imageUrl: _ctx.path,
            imageSize: _ctx.imageSize
          }, null, 8, ["imageUrl", "imageSize"]))
        : _createCommentVNode("", true),
      (_ctx.path == '')
        ? (_openBlock(), _createBlock("div", _hoisted_4))
        : _createCommentVNode("", true)
    ]),
    _createVNode("div", _hoisted_5, [
      _createVNode("p", _hoisted_6, _toDisplayString(_ctx.name), 1),
      _createVNode("div", _hoisted_7, [
        _createVNode("p", _hoisted_8, _toDisplayString(_ctx.score), 1),
        _hoisted_9
      ])
    ])
  ]))
}